export const getInteractionEmoji = (type) => {
  if (!type) return '🤝';
  const map = {
    coffee: '☕',
    meeting: '📅',
    call: '📞',
    phone: '📞',
    lunch: '🍽️',
    dinner: '🍽️',
    catchup: '👥',
    chat: '💬',
    video: '🎥',
    trip: '✈️',
    event: '🎟️',
  };
  return map[type.toLowerCase()] || '🤝';
};
